import React from 'react'
import { LiveLink } from '~/components/LiveLink'
import { formatDateTime } from '~/utils/date'

export function MeetingTitle({ title, href }: { title: string; href?: string }) {
  return (
    <LiveLink
      className={`text-primary text-base ${window.jump.layoutV2Enabled ? 'line-clamp-1 truncate text-ellipsis' : 'line-clamp-3'}`}
      href={href}
    >
      {title}
    </LiveLink>
  )
}

export function RecordingDateTime({ startedAtUnixMs }: { startedAtUnixMs?: number }) {
  return startedAtUnixMs ? (
    <div className="text-secondary whitespace-nowrap">{formatDateTime(startedAtUnixMs)}</div>
  ) : (
    <>&nbsp;</>
  )
}
